import {
  offline,
  online,
  queryconfig,
  querylog,
  saveDailyKnotConfig,
} from '@/services/config/dailyConfig';

export default {
  namespace: 'dailyConfig',
  state: {},

  effects: {
    *saveDailyKnotConfig({ payload, callback }, { call, put }) {
      const response = yield call(saveDailyKnotConfig, payload);
      if (callback) callback(response);
    },
    *offline({ payload, callback }, { call, put }) {
      const response = yield call(offline, payload);
      if (callback) callback(response);
    },
    *online({ payload, callback }, { call, put }) {
      const response = yield call(online, payload);
      if (callback) callback(response);
    },
    *queryconfig({ payload, callback }, { call, put }) {
      const response = yield call(queryconfig, payload);
      if (callback) callback(response);
    },
    *querylog({ payload, callback }, { call, put }) {
      const response = yield call(querylog, payload);
      if (callback) callback(response);
    },
  },

  reducers: {},
};
